import { render, staticRenderFns } from "./WeekDays.vue?vue&type=template&id=db6ce018&scoped=true&"
import script from "./WeekDays.vue?vue&type=script&lang=js&"
export * from "./WeekDays.vue?vue&type=script&lang=js&"
import style0 from "./WeekDays.vue?vue&type=style&index=0&id=db6ce018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6ce018",
  null
  
)

export default component.exports